import { NgModule } from '@angular/core';

import { ProtocolDroidDirective } from './directives/protocol-droid.directive';

@NgModule({
  declarations: [ProtocolDroidDirective],
  exports: [ProtocolDroidDirective]
})
export class ProtocolDroidModule {}
